import React from "react";
import { useAppointment } from "./hooks/useAppointment";
import { Appointment } from "./Appointment";
import { OutOfOffice } from "./OutOfOffice";
import { Loading } from "../../../../../boxes/Loading/Loading";

/**
 * @param {{
 *  id: number;
 *  onClose: () => void;
 *  refetchAppointments?: () => void;
 *  onFetchSuccess: (appt: Record<string, any>) => void;
 * }} props
 */
export function ModalAppointmentDetails(props) {
  const { appointment, isAppointmentLoading } = useAppointment(
    props.id,
    props.onClose,
    props.onFetchSuccess,
  );

  return (
    <div className="blackOverlay">
      <div className="vert-middle">
        <div className="loyaltyMembership start-program-main">
          {isAppointmentLoading && <Loading center />}
          {!isAppointmentLoading && (
            <>
              {appointment?.isOutOfOffice ? (
                <OutOfOffice {...props} />
              ) : (
                <Appointment {...props} />
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
